export const selectMyProvider = (state) => state.MyProvider.data;
export const selectIsLoading = (state) => state.MyProvider.isLoading;
export const selectError = (state) => state.MyProvider.error;
